<app-sub-header [pageTitle]="'Contacts' | translate"></app-sub-header>

<div class="padded-container">
  <ul>
    <li *ngFor="let contact of organizationContacts">
      <p [innerHTML]="contact.originalRow"></p>
    </li>
  </ul>
  <ul>
    <li *ngFor="let contact of clientContacts">
      <p [innerHTML]="contact.originalRow"></p>
    </li>
  </ul>
</div>